import { Component, type OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ReplaySubject, takeUntil } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'xilo-mono-agency-locator',
  templateUrl: './agency-locator.component.html',
  styleUrls: ['./agency-locator.component.scss'],
  styles: [`
    .locator-card{
      border: #B4B4BB solid 1px;
    }
    ::ng-deep .mat-mdc-select{
      all: initial !important;
    }
  `]
})

export class AgencyLocatorComponent implements OnInit, OnDestroy {
  selectedValue = '';
  title = '';
  subTitle = '';
  isEmployeePage = false;
  isContactFormPage = false;
  isOrlandoMagicPage = false;
  isCityNationalBankPage = false;
  pageUrl = 'https://quotes.xilo.io/';
  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  employeeStates: { value: string, link: string }[] = [
    { value: 'Alabama', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Alaska', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Arizona', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Arkansas', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'California', link: 'assured-partners-ventura/tazRPp?employee=true' },
    { value: 'Colorado', link: 'assured-partners-colorado/eMT_Y6?employee=true' },
    { value: 'Connecticut',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Delaware', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Florida',link: 'assured-partners-lake-mary/WH2ZLX?employee=true' },
    { value: 'Georgia', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Hawaii',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Idaho', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Illinois', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Indiana', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Iowa', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Kansas', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Kentucky', link: 'assured-partners-lexington/_UBJkX?employee=true' },
    { value: 'Louisiana',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Maine', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Maryland', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Massachusetts', link: 'assuredpartners-10/Hh7pRK?employee=true' },
    { value: 'Michigan', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Minnesota', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Mississippi', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Missouri', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Montana', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Nebraska',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Nevada', link: '1lPxiZ?employee=true' },
    { value: 'Las Vegas', link: 'mQMCd-?employee=true' },
    { value: 'New Hampshire',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'New Jersey', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'New Mexico', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'New York', link: '3ANljf?employee=true' },
    { value: 'North Carolina', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'North Dakota', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Ohio', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Oklahoma', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Oregon', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Pennsylvania', link: 'assuredpartners-wilkes-barre/3D1O0o?employee=true' },
    { value: 'Rhode Island', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'South Carolina', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'South Dakota', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Tennessee', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Texas', link: 'assured-partners-plano-/M8yNia?employee=true' },
    { value: 'Utah', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Vermont', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Virginia', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Washington', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'West Virginia',link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Wisconsin', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
    { value: 'Wyoming', link: 'assured-partners-sterling-/ueDxN4?employee=true' },
  ];

  states: { value: string, link: string }[] = [
    { value: 'Alabama', link: 'assuredpartners---southeast-region/jqK2Th' },
    { value: 'Alaska', link: 'assuredpartners-las-vegas-/kG9AKV' },
    { value: 'Arizona', link: 'assuredpartners-las-vegas-/A_miev' },
    { value: 'Arkansas', link: 'assured-partners-plano-/wf5AmL' },
    { value: 'California', link: 'assuredpartners-las-vegas-/xhNcsO' },
    { value: 'Colorado', link: 'assuredpartners-las-vegas-/onjDGo' },
    { value: 'Connecticut', link: 'assuredpartners-10/9tNjmm' },
    { value: 'Delaware', link: 'assuredpartners-wilkes-barre/lvkH8w' },
    { value: 'Florida', link: 'assured-partners-lake-mary/8QLd0e' },
    { value: 'Georgia', link: 'assuredpartners---southeast-region/tEDBw6' },
    { value: 'Hawaii', link: 'assuredpartners-las-vegas-/kEQw6n' },
    { value: 'Idaho', link: 'assuredpartners-las-vegas-/KQ2V2t' },
    { value: 'Illinois', link: 'assured-partners-sterling-/Rf7QHm' },
    { value: 'Indiana', link: 'assured-partners-lexington/wLScZN' },
    { value: 'Iowa', link: 'assured-partners-sterling-/cftJm3' },
    { value: 'Kansas', link: 'assured-partners-plano-/wRy7li' },
    { value: 'Kentucky', link: 'assured-partners-lexington/8rQ56m' },
    { value: 'Louisiana', link: 'assuredpartners---southeast-region/zQ9RYb' },
    { value: 'Maine', link: 'assuredpartners-10/Gfg-4Y' },
    { value: 'Maryland', link: 'assuredpartners-wilkes-barre/itqAaV' },
    { value: 'Massachusetts', link: 'assuredpartners-10/M-beX6' },
    { value: 'Michigan', link: 'assured-partners-sterling-/32r3wR' },
    { value: 'Minnesota', link: 'assured-partners-sterling-/YHPiAW' },
    { value: 'Mississippi', link: 'assuredpartners---southeast-region/b2E3s8' },
    { value: 'Missouri', link: 'assured-partners-plano-/TwwoVM' },
    { value: 'Montana', link: 'assuredpartners-las-vegas-/238lar' },
    { value: 'Nebraska', link: 'assured-partners-plano-/4juS0N' },
    { value: 'Nevada', link: 'assuredpartners-las-vegas-/Zzlp4c' },
    { value: 'New Hampshire', link: 'assuredpartners-10/SDgYuM' },
    { value: 'New Jersey', link: 'assuredpartners-wilkes-barre/TJ34hY' },
    { value: 'New Mexico', link: 'assuredpartners-las-vegas-/-y0kLG' },
    { value: 'New York', link: 'assuredpartners-10/9tNjmm' },
    { value: 'North Carolina', link: 'assuredpartners-wilkes-barre/_7SLIT' },
    { value: 'North Dakota', link: 'assured-partners-sterling-/y0fUXp' },
    { value: 'Ohio', link: 'assured-partners-lexington/uzhszr' },
    { value: 'Oklahoma', link: 'assured-partners-plano-/7E2Fna' },
    { value: 'Oregon', link: 'assuredpartners-las-vegas-/m4VWIO' },
    { value: 'Pennsylvania', link: 'assuredpartners-wilkes-barre/-TsI4t' },
    { value: 'Rhode Island', link: 'assuredpartners-10/LWXSAg' },
    { value: 'South Carolina', link: 'assuredpartners-wilkes-barre/phYs7q' },
    { value: 'South Dakota', link: 'assuredpartners-las-vegas-/nvuWI9' },
    { value: 'Tennessee', link: 'assured-partners-lexington/IQp0bJ' },
    { value: 'Texas', link: 'assured-partners-plano-/kaGLHx' },
    { value: 'Utah', link: 'assuredpartners-las-vegas-/6KdpNk' },
    { value: 'Vermont', link: 'assuredpartners-10/Q8oz9T' },
    { value: 'Virginia', link: 'assuredpartners-wilkes-barre/ABfI-D' },
    { value: 'Washington', link: 'assuredpartners-las-vegas-/Xz1Tju' },
    { value: 'West Virginia', link: 'assured-partners-lexington/g6RMOd' },
    { value: 'Wisconsin', link: 'assured-partners-sterling-/jHvgV1' },
    { value: 'Wyoming', link: 'assuredpartners-las-vegas-/8_QKdf' }
  ];

  orlandoMagicStates: { value: string, link: string }[] = [
    { value: 'Alabama', link: 'assuredpartners---southeast-region/aip_M1' },
    { value: 'Alaska', link: 'assuredpartners-las-vegas-/U01dGi' },
    { value: 'Arizona', link: 'assuredpartners-las-vegas-/FUDwT7' },
    { value: 'Arkansas', link: 'assured-partners-plano-/WVUME-' },
    { value: 'California', link: 'assuredpartners-las-vegas-/E40g0t' },
    { value: 'Colorado', link: 'assuredpartners-las-vegas-/eBI2Mh' },
    { value: 'Connecticut', link: 'assuredpartners-10/_74NN4' },
    { value: 'Delaware', link: 'assuredpartners-wilkes-barre/LhdgvN' },
    { value: 'Florida', link: 'assured-partners-lake-mary/34IUgJ' },
    { value: 'Georgia', link: 'assuredpartners---southeast-region/RbXOEq' },
    { value: 'Hawaii', link: 'assuredpartners-las-vegas-/mgivho' },
    { value: 'Idaho', link: 'assuredpartners-las-vegas-/4B-Yib' },
    { value: 'Illinois', link: 'assured-partners-sterling-/tjOpno' },
    { value: 'Indiana', link: 'assured-partners-lexington/hH1R-4' },
    { value: 'Iowa', link: 'assured-partners-sterling-/mE38ze' },
    { value: 'Kansas', link: 'assured-partners-plano-/pLX4fB' },
    { value: 'Kentucky', link: 'assured-partners-lexington/xRMVl0' },
    { value: 'Louisiana', link: 'assuredpartners---southeast-region/kltkGl' },
    { value: 'Maine', link: 'assuredpartners-10/BT_tl3' },
    { value: 'Maryland', link: 'assuredpartners-wilkes-barre/nyemYb' },
    { value: 'Massachusetts', link: 'assuredpartners-10/o9Pzb0' },
    { value: 'Michigan', link: 'assured-partners-sterling-/Dtlpc7' },
    { value: 'Minnesota', link: 'assured-partners-sterling-/-upUe0' },
    { value: 'Mississippi', link: 'assuredpartners---southeast-region/C77ZQ8' },
    { value: 'Missouri', link: 'assured-partners-plano-/bOE53V' },
    { value: 'Montana', link: 'assuredpartners-las-vegas-/nyr3Uc' },
    { value: 'Nebraska', link: 'assured-partners-plano-/R9jmaI' },
    { value: 'Nevada', link: 'assuredpartners-las-vegas-/-TBbuQ' },
    { value: 'New Hampshire', link: 'assuredpartners-10/7lVBLS' },
    { value: 'New Jersey', link: 'assuredpartners-wilkes-barre/rURKVB' },
    { value: 'New Mexico', link: 'assuredpartners-las-vegas-/jqeyzl' },
    { value: 'New York', link: 'assuredpartners-10/-9p1zZ' },
    { value: 'North Carolina', link: 'assuredpartners-wilkes-barre/gPs_wX' },
    { value: 'North Dakota', link: 'assured-partners-sterling-/Jl3GOO' },
    { value: 'Ohio', link: 'assured-partners-lexington/pr5beW' },
    { value: 'Oklahoma', link: 'assured-partners-plano-/kuNscE' },
    { value: 'Oregon', link: 'assuredpartners-las-vegas-/9I2DgE' },
    { value: 'Pennsylvania', link: 'assuredpartners-wilkes-barre/J5spvT' },
    { value: 'Rhode Island', link: 'assuredpartners-10/mZqmsd' },
    { value: 'South Carolina', link: 'assuredpartners-wilkes-barre/BkPDXL' },
    { value: 'South Dakota', link: 'assuredpartners-las-vegas-/1ieegs' },
    { value: 'Tennessee', link: 'assured-partners-lexington/lsu-ug' },
    { value: 'Texas', link: 'assured-partners-plano-/bZvNq6' },
    { value: 'Utah', link: 'assuredpartners-las-vegas-/mjk-Xs' },
    { value: 'Vermont', link: 'assuredpartners-10/JgJNHQ' },
    { value: 'Virginia', link: 'assuredpartners-wilkes-barre/hvbVxt' },
    { value: 'Washington', link: 'assuredpartners-las-vegas-/q680o0' },
    { value: 'West Virginia', link: 'assured-partners-lexington/sBKlua' },
    { value: 'Wisconsin', link: 'assured-partners-sterling-/9yphGT' },
    { value: 'Wyoming', link: 'assuredpartners-las-vegas-/qKMV3j' }
  ];

  contactFormStates: { value: string; link: string }[] = [
    { value: 'AR', link: 'assured-partners-plano-/65XLIq' },
    { value: 'KS', link: 'assured-partners-plano-/bJ0Hsd' },
    { value: 'MO', link: 'assured-partners-plano-/-X89uk' },
    { value: 'NE', link: 'assured-partners-plano-/C5kPf3' },
    { value: 'OK', link: 'assured-partners-plano-/U5ICBZ' },
    { value: 'TX', link: 'assured-partners-plano-/am-8HM' },
    { value: 'IA', link: 'assured-partners-sterling-/v1EK-p' },
    { value: 'IL', link: 'assured-partners-sterling-/BUPucg' },
    { value: 'MI', link: 'assured-partners-sterling-/nzIhxP' },
    { value: 'MN', link: 'assured-partners-sterling-/3nlu2r' },
    { value: 'ND', link: 'assured-partners-sterling-/FHGlwo' },
    { value: 'WI', link: 'assured-partners-sterling-/PoDy2c' },
    { value: 'DE', link: 'assuredpartners-wilkes-barre/JovvU5' },
    { value: 'MD', link: 'assuredpartners-wilkes-barre/5s-Ccn' },
    { value: 'NC', link: 'assuredpartners-wilkes-barre/sStcQf' },
    { value: 'NJ', link: 'assuredpartners-wilkes-barre/5r6VPw' },
    { value: 'PA', link: 'assuredpartners-wilkes-barre/itOMng' },
    { value: 'SC', link: 'assuredpartners-wilkes-barre/F1er7S' },
    { value: 'VA', link: 'assuredpartners-wilkes-barre/OP9D4w' },
    { value: 'IN', link: 'assured-partners-lexington/VfYIBA' },
    { value: 'KY', link: 'assured-partners-lexington/49Up7t' },
    { value: 'OH', link: 'assured-partners-lexington/QJS6UI' },
    { value: 'TN', link: 'assured-partners-lexington/9gzkup' },
    { value: 'WV', link: 'assured-partners-lexington/u7FQBU' },
    { value: 'CT', link: 'assuredpartners-10/3DmSyD' },
    { value: 'MA', link: 'assuredpartners-10/1gA3_i' },
    { value: 'ME', link: 'assuredpartners-10/OCfmpn' },
    { value: 'NH', link: 'assuredpartners-10/_RZDxJ' },
    { value: 'NY', link: 'assuredpartners-10/X48PP2' },
    { value: 'RI', link: 'assuredpartners-10/FMus4Y' },
    { value: 'VT', link: 'assuredpartners-10/00jTXR' },
    { value: 'AL', link: 'assuredpartners---southeast-region/Tci5mE' },
    { value: 'GA', link: 'assuredpartners---southeast-region/4F-S-c' },
    { value: 'LA', link: 'assuredpartners---southeast-region/ZaiKaS' },
    { value: 'MS', link: 'assuredpartners---southeast-region/CIG1cq' },
    { value: 'FL', link: 'assured-partners-lake-mary/SGvPN5' },
    { value: 'AK', link: 'assuredpartners-las-vegas-/1e5u2p' },
    { value: 'AZ', link: 'assuredpartners-las-vegas-/RMQXiw' },
    { value: 'CA', link: 'assuredpartners-las-vegas-/3FVhtK' },
    { value: 'CO', link: 'assuredpartners-las-vegas-/bB-TW3' },
    { value: 'HI', link: 'assuredpartners-las-vegas-/uJri9T' },
    { value: 'ID', link: 'assuredpartners-las-vegas-/aQB4vE' },
    { value: 'MT', link: 'assuredpartners-las-vegas-/9MuI5T' },
    { value: 'NM', link: 'assuredpartners-las-vegas-/6vUm7O' },
    { value: 'NV', link: 'assuredpartners-las-vegas-/XwIrnM' },
    { value: 'OR', link: 'assuredpartners-las-vegas-/spJvGp' },
    { value: 'SD', link: 'assuredpartners-las-vegas-/UuiX2T' },
    { value: 'UT', link: 'assuredpartners-las-vegas-/Er3hUI' },
    { value: 'WA', link: 'assuredpartners-las-vegas-/C9pzPV' },
    { value: 'WY', link: 'assuredpartners-las-vegas-/cxM65-' },
  ];
  
  cityNationalBankStates: { value: string; link: string }[] = [
    { value: 'Arkansas', link: 'assured-partners-plano-/uVhMBk' },
    { value: 'Kansas', link: 'assured-partners-plano-/DGAKQ0' },
    { value: 'Missouri', link: 'assured-partners-plano-/R_ft41' },
    { value: 'Nebraska', link: 'assured-partners-plano-/CVR1P8' },
    { value: 'Oklahoma', link: 'assured-partners-plano-/q7ssZ4' },
    { value: 'Texas', link: 'assured-partners-plano-/8GtDS8' },
    { value: 'Iowa', link: 'assured-partners-sterling-/t_6xi7' },
    { value: 'Illinois', link: 'assured-partners-sterling-/17OJEl' },
    { value: 'Michigan', link: 'assured-partners-sterling-/aTWMum' },
    { value: 'Minnesota', link: 'assured-partners-sterling-/1elKT6' },
    { value: 'North Dakota', link: 'assured-partners-sterling-/imZ_hq' },
    { value: 'Wisconsin', link: 'assured-partners-sterling-/kY0Ydp' },
    { value: 'Delaware', link: 'assuredpartners-wilkes-barre/t6GAzv' },
    { value: 'Maryland', link: 'assuredpartners-wilkes-barre/yEZdLW' },
    { value: 'North Carolina', link: 'assuredpartners-wilkes-barre/jvcNHr' },
    { value: 'New Jersey', link: 'assuredpartners-wilkes-barre/4tGLa_' },
    { value: 'Pennsylvania', link: 'assuredpartners-wilkes-barre/zwrsto' },
    { value: 'South Carolina', link: 'assuredpartners-wilkes-barre/EO1Rm7' },
    { value: 'Virginia', link: 'assuredpartners-wilkes-barre/vEU4qZ' },
    { value: 'Indiana', link: 'assured-partners-lexington/FkhPvr' },
    { value: 'Kentucky', link: 'assured-partners-lexington/nr4f8l' },
    { value: 'Ohio', link: 'assured-partners-lexington/WBhLZq' },
    { value: 'Tennessee', link: 'assured-partners-lexington/AQpM0s' },
    { value: 'West Virginia', link: 'assured-partners-lexington/DLBEcc' },
    { value: 'Connecticut', link: 'assuredpartners-10/brEPm2' },
    { value: 'Massachusetts', link: 'assuredpartners-10/Tyn7A2' },
    { value: 'Maine', link: 'assuredpartners-10/4ZPFJZ' },
    { value: 'New Hampshire', link: 'assuredpartners-10/RcNH6k' },
    { value: 'New York', link: 'assuredpartners-10/Pu7Ml6' },
    { value: 'Rhode Island', link: 'assuredpartners-10/RWdAai' },
    { value: 'Vermont', link: 'assuredpartners-10/E3QXa2' },
    { value: 'Alabama', link: 'assuredpartners---southeast-region/V3j_Rj' },
    { value: 'Georgia', link: 'assuredpartners---southeast-region/bDtAMj' },
    { value: 'Louisiana', link: 'assuredpartners---southeast-region/FQqfXu' },
    { value: 'Mississippi', link: 'assuredpartners---southeast-region/_T6gIZ' },
    { value: 'Florida', link: 'assured-partners-lake-mary/xLyRZQ' },
    { value: 'Alaska', link: 'assuredpartners-las-vegas-/EbU0gU' },
    { value: 'Arizona', link: 'assuredpartners-las-vegas-/TA6Jz6' },
    { value: 'California', link: 'assuredpartners-las-vegas-/3JtV_x' },
    { value: 'Colorado', link: 'assuredpartners-las-vegas-/3kw6oL' },
    { value: 'Hawaii', link: 'assuredpartners-las-vegas-/-zs9Yw' },
    { value: 'Idaho', link: 'assuredpartners-las-vegas-/rYXZ6O' },
    { value: 'Montana', link: 'assuredpartners-las-vegas-/flNPJg' },
    { value: 'New Mexico', link: 'assuredpartners-las-vegas-/zlYQSE' },
    { value: 'Nevada', link: 'assuredpartners-las-vegas-/QImKuT' },
    { value: 'Oregon', link: 'assuredpartners-las-vegas-/mIJZhf' },
    { value: 'South Dakota', link: 'assuredpartners-las-vegas-/PrTVWW' },
    { value: 'Utah', link: 'assuredpartners-las-vegas-/gPq2JZ' },
    { value: 'Washington', link: 'assuredpartners-las-vegas-/GmIr_e' },
    { value: 'Wyoming', link: 'assuredpartners-las-vegas-/b90Izp' }
  ];

  trustedUrl: any;
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.updateTitle('Personal Insurance Quotes | AssuredPartners');
    this.updateFavicon('https://d2e6d30q686u4a.cloudfront.net/favicons/assured_partners.ico');
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(params => {
      if (params['contact-form'] === 'true') {
        this.title = 'Let Us Do the Heavy Lifting for You';
        this.subTitle = 'After analyzing your needs, a real agent will be in touch.\nWe review your options together, educate you on important details, and answer your questions.';
        this.isContactFormPage = true;
        this.states = this.contactFormStates;
      }
      if (params.employee === 'true') {
        this.title = 'We\'re happy to help our employees navigate their coverage.';
        this.isEmployeePage = true;
        this.states = this.employeeStates;
      }
      if (params['city-national-bank'] === 'true') {
        this.title = 'City National Bank Insurance Solutions';
        this.isCityNationalBankPage = true;
        this.states = this.cityNationalBankStates.map(state => {
          return {
            link: `${state.link}?ref=${params.ref}&hideNav=true`,
            value: state.value
          }
        });
      }
      if (params.ref) {
        this.isOrlandoMagicPage = true;
        this.title = 'Protection for champions on and off the court.';
        this.states = this.orlandoMagicStates.map(state => {
          return {
            link: `${state.link}?ref=${params.ref}&hideNav=true`,
            value: state.value
          }
        })
      }
    });

    this.states.sort((a,b) => this._sortAlphabetically(a,b))
    const allOthers = this.states.findIndex(v => v.value === 'All Other States')
    this.states.push(this.states.splice(allOthers, 1)[0]);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  private updateFavicon(iconUrl: string): void {
    const link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.renderer.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconUrl;

    if (!link.parentElement) {
      this.renderer.appendChild(this.document.head, link);
    }
  }

  private updateTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  private updateMetaTag(name: string, content: string): void {
    this.metaService.updateTag({ name, content });
  }

  onOptionsSelected(ev){
    // const testingURL = 'http://localhost:4200/form/list-all-forms?companyId=919104';
    // TODO: don't hardcode PROD url here
    const url = this.pageUrl + ev
    this.trustedUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private _sortAlphabetically(a,b):number{
    const nameA = a.value.toUpperCase();
    const nameB = b.value.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  }
}